import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageRessourcePipe } from './image-ressource.pipe';

@NgModule({
  declarations: [ImageRessourcePipe],
  exports: [ImageRessourcePipe],
  imports: [
    CommonModule
  ]
})
export class PipesModule { }
